import React from "react";
import { If } from "./If";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

const LOADER_COLOR = "#31AA49";

export const Loader: React.FunctionComponent<{
  loading: boolean;
  fullPage?: boolean
  height?: string
}> = ({ loading, children, fullPage = true, height }) => (
  <>
    <If predicate={loading && !fullPage}>
      <Box
        sx={{
          height: height ? height : "auto"
        }}
      >
        <CircularProgress
          size={40}
          sx={{
            color: LOADER_COLOR
          }}
        />
      </Box>
    </If>

    <If predicate={loading && fullPage}>
      <Backdrop
        open={loading}
        sx={{
          zIndex: 100,
          // position: "absolute",
          backgroundColor: "#fff"
          // backgroundColor: 'rgba(255, 255, 255, 0.8)'
        }}

      >
        <CircularProgress
          size={120}
          sx={{
            color: LOADER_COLOR
          }}
        />
      </Backdrop>
    </If>

    <If predicate={!loading}>{children}</If>
  </>
);
